import React from 'react';
import { Search, X } from 'lucide-react';

interface SearchBarProps {
  value: string;
  onChangeText: (text: string) => void;
  onClear: () => void;
}

export const SearchBar: React.FC<SearchBarProps> = ({ value, onChangeText, onClear }) => {
  return (
    <div className="gr-search-container">
      <Search size={20} color="rgba(255, 255, 255, 0.8)" className="gr-search-icon" />
      <input
        type="text"
        value={value}
        onChange={(e) => onChangeText(e.target.value)}
        placeholder="Buscar jogador ou torneio..."
        className="gr-search-input"
      />
      {value.length > 0 && (
        <button onClick={onClear} className="gr-search-clear">
          <X size={14} color="white" />
        </button>
      )}
    </div>
  );
};
